export function obterTrimestreAtual() {

    const dataAtual = new Date();
    const anoAtual = dataAtual.getFullYear();


    const dataInicioPrimeiroTrimestre = new Date(anoAtual, 0, 1); // 1º de janeiro do ano atual
    const dataFimPrimeiroTrimestre = new Date(anoAtual, 5, 1); // 4 de junho do ano atual
    const dataInicioTerceiroTrimestre = new Date(anoAtual, 8, 1); // 1º de setembro do ano atual

    if (dataAtual < dataFimPrimeiroTrimestre) {
        return '1';
    } else if (dataAtual < dataInicioTerceiroTrimestre) {
        return '2';
    } else {
        return '3';
    }
}